// @flow

import React from 'react'
import videojs from 'video.js'
import styled from 'styled-components'
import { Player } from 'video-react'
import type { ReactComponentStyled } from 'styled-components'
import Bowser from 'bowser'

const Video: ReactComponentStyled<{}> = styled.video`
  width: 100%;
  height: 100%;

  @media only screen and (orientation: landscape) and (min-width : 375px) and (max-width : 823px) {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 445px) {
    width: 100%;
    height: 100%;
  }
`
// add for testing purpose
Video.displayName = 'Video'

type VideoPlayerProps = {
  videoJsOptions: Object,
}

export default class VideoPlayer extends React.Component<VideoPlayerProps, {}> {
  player: videojs
  videoNode: any
  componentDidMount () {
    // instantiate Video.js
    const { videoJsOptions } = this.props
    this.player = videojs(this.videoNode, videoJsOptions)
    this.player.src(videoJsOptions.sources)
  }

  // destroy player on unmount
  componentWillUnmount () {
    if (this.player) {
      this.player.dispose()
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render () {
    const { videoJsOptions } = this.props
    const browser = Bowser.parse(window.navigator.userAgent)
    const isSafariMobile = browser.browser.name === 'Safari' && browser.platform.type === 'mobile'
    if (isSafariMobile) {
      return (
        <div data-vjs-player className='test2'>
          <Video ref={node => (this.videoNode = node)} className='video-js' />
          <Player>
            <source src={videoJsOptions.src} />
          </Player>
        </div>
      )
    } else {
      return (
        <div data-vjs-player className='test2'>
          <Video ref={node => (this.videoNode = node)} className='video-js' />
        </div>
      )
    }
  }
}
